/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';

import { isWeb } from '@global/screens';
import Colors from '@global/colors';

import PropTypes from 'prop-types';

const propTypes = {
  activeTab: PropTypes.string,
  onCallback: PropTypes.func,
};

const defaultProps = {
  activeTab: 'product',
  onCallback: () => {},
};

const CatalogTab = ({ activeTab = 'product', onCallback = () => {} }) => {
  const tabs = [
    {
      label: 'Product',
      value: 'product',
    },
    {
      label: 'Categories',
      value: 'categories',
    },
    {
      label: 'Best Seller',
      value: 'best-seller',
    },
    {
      label: 'New Arrival',
      value: 'new-arrival',
    },
    {
      label: 'Promo/Info',
      value: 'promo',
    },
  ];

  return (
    <View>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        style={{
          width: '100%',
          borderBottomColor: Colors.grey0,
          borderBottomWidth: 2,
          marginBottom: isWeb ? 20 : 0,
        }}>
        {tabs.map((item, idx) => (
          <TouchableOpacity
            key={`tab-${idx}`}
            activeOpacity={0.8}
            style={[
              styles.tab,
              activeTab == item.value
                ? {
                    borderBottomColor: Colors.blue0,
                  }
                : {},
            ]}
            onPress={() => onCallback(item.value)}>
            <SociollaText
              type={activeTab == item.value ? 'medium' : ''}
              style={activeTab == item.value ? { color: Colors.blue0 } : {}}>
              {item.label}
            </SociollaText>
          </TouchableOpacity>
        ))}
      </ScrollView>
    </View>
  );
};

CatalogTab.propTypes = propTypes;
CatalogTab.defaultProps = defaultProps;

const styles = StyleSheet.create({
  tab: {
    borderBottomWidth: 2,
    borderBottomColor: Colors.transparent,
    paddingVertical: 12,
    paddingHorizontal: 20,
    ...(!isWeb
      ? {
          backgroundColor: Colors.white,
        }
      : {}),
  },
});

export default React.memo(CatalogTab, (prev, next) => prev == next);
